/** The `/contacto` page in English. See `locales/es/contacto.ts`. */

export const contacto = {
  eyebrow: "Let's talk",
  titulo: 'Tell us about your next event',
  lead: 'We will walk you through the platform with real data from an event and estimate what to expect at yours. Or just email us directly.',
  planInteres: 'Plan of interest:',
  horario: 'We reply during business hours, Mexico City time.',

  tipoSolicitud: 'Request type',
  tipos: {
    demo: 'Book a demo',
    contacto: 'Contact',
    loi: 'Letter of Intent',
  },

  perfilPregunta: 'How would you describe yourself?',
  perfiles: {
    marca: 'Brand / Exhibitor',
    organizador: 'Event organizer',
    otro: 'Other',
  },

  campos: {
    nombre: 'Name',
    empresa: 'Company',
    email: 'Email',
    telefono: 'Phone (optional)',
    mensaje: 'Message',
    mensajePlaceholder:
      'Tell us about the event: date, venue, roughly how many booths or attendees.',
    honeypot: 'Do not fill in',
  },

  errores: {
    nombre: 'Please enter your name.',
    empresa: 'Please enter your company name.',
    email: 'Please enter a valid email address.',
    mensaje: 'Tell us a little more (10 characters minimum).',
  },

  enviar: 'Send request',

  estados: {
    graciasBot: 'Thank you, we received your message.',
    mailtoAbierto: (correo: string) =>
      `We opened your mail app with the message ready to send. If nothing opened, this computer has no mail app configured: copy what you wrote and send it to ${correo}.`,
  },

  porCorreo: {
    aviso:
      'This form does not send anything on its own: it drafts an email and opens it in your mail app so you can review it and send it yourself. You can also write to us directly at',
  },

  mailto: {
    asuntoDemo: 'Demo request — ILUMETRIA',
    asuntoLoi: 'Letter of Intent — ILUMETRIA',
    asuntoContacto: 'Contact — ILUMETRIA',
    nombre: 'Name',
    empresa: 'Company',
    correo: 'Email',
    telefono: 'Phone',
    perfil: 'Profile',
    planInteres: 'Plan of interest',
  },
};
